import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { WorksiteClient } from '../clients/oreg-api/worksite.client';
import { CreateWorksiteModel } from '../models/create-worksite.model';
import { ListWorksite } from '../models/list-worksite.model';
import { WorksiteDetail } from '../models/worksite-detail.model';
import { SearchResultsRepository } from '../repositories/search-result.repository';

@Injectable({ providedIn: 'root' })
export class WorksitesCommand {
  constructor(
    private worksiteClient: WorksiteClient,
    private searchResultsRepository: SearchResultsRepository,
  ) {}

  public selectWorksite(
    worksiteProvider: string,
    worksiteId: string,
  ): Observable<WorksiteDetail> {
    return this.worksiteClient.selectWorksite(worksiteProvider, worksiteId);
  }

  public extendWorksites(
    ids: string[],
    worksiteId: string,
    companyId: string,
  ): Observable<ListWorksite[]> {
    return this.worksiteClient.extendWorksites(ids).pipe(
      tap((extendedWorksites) => {
        this.searchResultsRepository.update(companyId, (draft) => {
          const worksite = draft.worksites.find(
            (w) => w.providerId === worksiteId,
          );
          worksite.identicalWorksites = worksite.identicalWorksites.map(
            (worksite) => {
              return extendedWorksites.find(
                (x) => x.providerId === worksite.providerId,
              );
            },
          );
          worksite.identicalWorksites.sort((a, b) => {
            const aDepartment = a.department ?? worksite.name;
            const bDepartment = b.department ?? worksite.name;
            return aDepartment.localeCompare(bDepartment);
          });
        });

        this.searchResultsRepository.setProps({
          extendedWorksites: [
            ...this.searchResultsRepository.getExtendedWorksites(),
            worksiteId,
          ],
        });
      }),
    );
  }

  public createWorksite(model: CreateWorksiteModel): Observable<ListWorksite> {
    return this.worksiteClient.createWorksite(model);
  }
}
